import React from 'react';
import { Row, Col } from '../../../components/Bootstrap/Bootstrap';
import {
  Text,
  Flex,
  Relative,
  Absolute,
  FlexCell,
} from '../../../assets/styles/components'
import InputOutlined from '../../../components/Input/InputOutlined'
import {blue} from '../../../assets/styles/styles'
import { TableAddress } from '../styles';
import { formatMoney } from '../../../utils/format'
import ErrorText from '../../../components/Error/ErrorText'
import Spinner from '../../../components/Loader/Spinner';

const TabVoucher = ({ 
  loading,
  loadingPromo,
  errorPromo,
  changeState, 
  data, 
  promotext, 
  addVoucher}) => {
  return (
    <Relative padding="25px 20px 40px 20px">
      <Row>
        <Flex margin="15px 0 13px" alignItems="center">
          <FlexCell flex={0.175}>
          <Text fontFamily="Arial" fontSize="14px" fontWeight="bold">Insert Voucher</Text>
          </FlexCell>
          <FlexCell flex={0.5}>
            <Relative>
              <InputOutlined
                placeholder="Insert promo code"
                value={promotext}
                onChange={e => changeState('promotext', e.target.value)}
                margin="0"
                padding="8px 74px 8px 6px"
                onKeyPress={e => {
                  if (e.key === 'Enter') addVoucher()
                }}
              />
              <Absolute top="50%" right="10px" transform="translateY(-50%)">
                <Text cursor="pointer" color={blue} onClick={addVoucher}>
                  Add
                </Text>
              </Absolute>
            </Relative>
          </FlexCell>
        </Flex>
        <Relative>
          {errorPromo ? (
            <ErrorText
              margin="0px 0 3px"
              style={{ fontSize: 12, textAlign: 'left'}}
            >
              {errorPromo}
            </ErrorText>
            ) : null}
        </Relative>
      </Row>
      <Row>
        <Col md={12}>
          <TableAddress>
            <thead>
              <tr>
                <th style={{width: '25%', fontFamily: 'Arial, sans-serif', fontSize: '15px'}}> Voucher Code</th>
                <th style={{width: '20%', fontFamily: 'Arial, sans-serif', fontSize: '15px'}}>Discount</th>
                <th style={{width: '35%', fontFamily: 'Arial, sans-serif', fontSize: '15px'}}>Description</th>
                <th style={{width: '10%', fontFamily: 'Arial, sans-serif', fontSize: '15px'}}>Available</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', paddingTop: 10 }}>
                    <Spinner className="fa-lg" />
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', paddingTop: 10 }}>
                    No vouchers available
                  </td>
                </tr>
              ) : (
                data.map((voucher, i) => (
                  <tr key={i}>
                    <td>
                      <b>{voucher.name}</b>
                      <br />{voucher.promo_code}
                    </td>
                    <td>
                        {voucher.discount_amount
                        ? `Rp. ${formatMoney(voucher.discount_amount)}`
                        : voucher.discount_delivery
                        ? `Rp. ${formatMoney(voucher.discount_delivery)}`
                        : voucher.discount_percentage
                        ? `${voucher.discount_percentage}%`
                        : null}
                    </td>
                    <td>
                      {voucher.description.replace(/<\/?p>/g, "")}
                    </td>
                    <td>
                      {voucher.remaining}
                    </td>
                    <td>
                      {/* Add action buttons here */}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </TableAddress>
        </Col>
      </Row>
    </Relative>
  );
};

export default TabVoucher;